/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI75262ResDataItem {
  
  /** 任务id */
  id?: number;
  
  /** 任务标题 */
  taskTitle?: string;
  
  /** 截止时间 */
  endTime?: any;
  
  /** 任务组ID,有则是任务组,无则是单任务 */
  groupId?: string;
  
  /** 任务状态 */
  taskStatus?: string;
  
  /** 是否正常 */
  isNormal?: string;
  
};
    
  



export type API75262Req = {};



export type API75262Res = IAPI75262ResDataItem[];


// 接口函数 75262 获取个人待办任务列表

export interface IUseGetAPI75262Return {
  /** 获取个人待办任务列表: 接口请求状态 */
  isAPI75262Loading: boolean;
  /** 获取个人待办任务列表: 接口请求返回数据 */
  dataAPI75262: API75262Res;
  /**  获取个人待办任务列表: 接口数据请求方法 */
  fetchAPI75262Data: ( config?: YWRequestConfig) => Promise<API75262Res>;
  /** 获取个人待办任务列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI75262 = ():IUseGetAPI75262Return => {
  let isMount = true;
  const [isAPI75262Loading, setIsAPI75262Loading] = useState(false);
  const [dataAPI75262, setDataAPI75262] = useState<API75262Res>({} as API75262Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/task/todo/list`;

  const fetchAPI75262Data = async ( config?: YWRequestConfig): Promise<API75262Res> => {
  
    if ( isMount ) {
      setIsAPI75262Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API75262Res>(`${basePath}/yoaichat-web/chat/task/todo/list`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI75262(res || {} as API75262Res);
        setIsAPI75262Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75262Loading(false);
      }
      return false as unknown as API75262Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75262Loading,
    dataAPI75262,
    fetchAPI75262Data,
    requestUrl,
  }
}

